import SettingLanguage from './SettingLanguage';

export default SettingLanguage;
